import axios from 'axios';

export default {
    async listSchedules(activityId, date) {
        return (await axios.get('/disponibilidade-horarios/' + activityId + '?quantity=0&day=' + date)).data;
    },
    async listPriceClassifications(activityId, date) {
        return (await axios.get('/classificacoes-precos/' + activityId+ '?&day=' + date)).data;
    }
};
